import type { PostProcessorModule } from 'i18next';

import { isTrackingEnabled, trackTranslationKey } from './index.ts';

/**
 * i18next post-processor that collects translation keys used on the current page.
 *
 * When translate mode is enabled, every `t()` call passes through this processor
 * which records the key in a global `Set`. The TranslateMode overlay then uses
 * the collected keys to highlight translatable strings and allow in-place editing.
 *
 * When tracking is disabled, the processor is a no-op and returns the value as-is.
 */
export const translationTrackerPostProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: 'translationTracker',
  process(value, key) {
    if (isTrackingEnabled()) {
      const keys = Array.isArray(key) ? key : [key];
      keys.forEach((k) => {
        trackTranslationKey(k);
      });
    }
    return value;
  },
};
